<ngx-loading [show]="loading" [config]="{backdropBorderRadius: '14px'}"></ngx-loading>
<h2 mat-dialog-title class="bgDialogHeader text-center">Work Order Notes
  <div class="pull-right">
    <a class="boxclose" (click)="onNoClick()"></a>
  </div>
</h2>
<mat-dialog-content>
  <div class="data-table-event-file" *ngIf="viewFullNotes">
    <button class="col-md-2 btn btn-semi-round bgBlue mr-2 mb-1 pull-right" (click)="addWoNote()">
      Add Note</button>
    <table id="accordion" class="table table-bordered">
      <thead class="wordwrap">
        <tr>
          <th scope="col">Date</th>
          <th scope="col">Details</th>
        </tr>
      </thead>
      <tbody *ngFor="let note of viewFullNotes">
        <tr>
          <td width="30%">{{note.wONdAdded | timezoneConvertDate}} <br><strong
              *ngIf="note.wONvc255Purpose === 'general'">{{note.wONTSLlNotedBy}}</strong>
            <strong *ngIf="note.wONvc255Purpose === 'customer'">{{note.wONvcAuthorID}}</strong>
          </td>
          <td width="70%">
            <div [innerHTML]="note.wONtextNote"></div> <br>
            <div *ngIf="note.wONvc255Purpose === 'customer' && note.WONTSLlAcknowledgedBy !== '' ">
              <strong>Acknowledged by: </strong>{{note.tSLvc255Name}}<br>
              <strong>Note: <br> </strong>{{note.wONtextAcknowledgeNote}}<br>
              <strong>On: </strong>{{note.wONdAcknowledgeOn | timezoneConvertDate}}                                    
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</mat-dialog-content>
<!-- 
<div class="col-12 col-sm-3 col-md-3 col-lg-3 ">
  <ng-template #dialog let-data let-ref="dialogRef">
    <nb-card style="width: 400px;margin-top: -1rem">
      <nb-card-header style="background: #0170bf !important;color: white"><button type="button" class="close"
          (click)="ref.close()">
          ×</button>Add Workorder Note</nb-card-header>
      <nb-card-body>
        <form>
          <textarea placeholder="Add work order note" name="txtWoNote" [(ngModel)]="woNoteDescription"></textarea>
          <button mat-raised-button class="btn btn-semi-round w-40 mt-2 bgBlue pull-right" (click)="saveWoNote()">
            Save
          </button>
        </form>
      </nb-card-body>
      <nb-card-footer style="padding: 0.25rem;">
        <button #btnClose mat-raised-button class="btn btn-semi-round w-40 mt-2 bgBlue pull-right"
          (click)="ref.close()">
          Close
        </button>
      </nb-card-footer>
    </nb-card>
  </ng-template>
</div> -->